<template>
  <v-app id="user_app" class="teal darken-4">
    <notification />

    <router-view />
  </v-app>
</template>

<script>
import Notification from '@/components/layout/Notification';
import { isMobile } from '@/utils/regex';
import { LocalStorage } from './enums/storage.enum';

// @vuese
// App
// @group App
export default {
  components: { Notification },
  mounted() {
    if (!process.env.VUE_APP_DISABLE_PWA) {
      if (isMobile() && !localStorage.getItem(LocalStorage.PWA_POPUP)) {
        this.$store.commit('system/showPopup');
      }
    } else {
      if (navigator.serviceWorker) {
        navigator.serviceWorker.getRegistrations().then(function(registrations) {
          for (let idx in registrations) {
            registrations[idx].unregister();
          }
        });
      }
    }
  }
};
</script>

<style src="./styles/styles.scss" lang="scss" />
